<div class="qwd-content-bodymain">

  <div class="qwd-error-code-container">
    @if (responseData) {
      <div class="modal-content-custom">
        @if (responseData?.toLowerCase() != 'success' && responseData ) {
          <div class="success-icon mb-3">
            <img src="assets/images/error_alert-circle.svg" alt="Success" />
          </div>
          <a href="https://qrowntech.com/" tabindex="-1" target="_blank" class="mb-3 qro-logo-mobile">
            <!-- <img src="assets/images/qro-logo-mobile.svg" alt="QROWNTECH" class="success-img" /> -->
          </a>
          <h4>{{ responseData }}</h4>
        } @else {
          <div class="success-icon mb-3">
            <img src="assets/images/check-circle.svg" alt="Success" />
          </div>
          <a href="https://qrowntech.com/" tabindex="-1" target="_blank" class="mb-3 qro-logo-mobile">
            <!-- <img src="assets/images/qro-logo-mobile.svg" alt="QROWNTECH" class="success-img" /> -->
          </a>
          <h4>{{ responseData  }}</h4>
        }
      </div>
    }
  </div>
  @if (isLoading) {
    <div class="page-load">
      <mat-spinner class="spinner"></mat-spinner>
    </div>
  }
  <!-- <h2 class="qwd-error-message">{{ responseData | json }}</h2> -->
</div>
